import * as React from 'react';

export interface OwnershipModalProperties {
  readonly entityType: string;
}
export class OwnershipModalComponent extends React.Component<OwnershipModalProperties> {
  render() {
    return (
      <div className="row center-xs">
        <h3>Are you sure you want to take over ownership of this {this.props.entityType}?</h3>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/service-work-order/dispatch/_components/dispatch-landing/ownership-modal.component.tsx